import React from "react";

const CustomText = ({
    className = "",
    imageUrl = "",
    titleClass = "",
    descClass = "",
    title = "",
    description,
    avatarSize = "md",
    avatar = false,
    hideLeft = false,
    borderRight = false,
    borderLeft = false,
    borderMargin = "mx-4"
}) => {
    return (
        <div
            className={`app-custom-text ${className} d-flex ${borderRight && "border-right"} ${
                borderLeft && "border-left"
            }`}
        >
            {!hideLeft && (
                <div className="">
                    {avatar ? (
                        imageUrl ? (
                            <img
                                src={imageUrl}
                                alt="img-thumbnail"
                                className={`avatar-${avatarSize} rounded-circle img-thumbnail`}
                            />
                        ) : (
                            <div
                                className={`avatar-${avatarSize} rounded-circle img-thumbnail d-flex align-items-center justify-content-center font-size-22 bg-theme-secondary fw-bold`}
                            >
                                {title.charAt(0)?.toUpperCase() || "#"}
                            </div>
                        )
                    ) : null}
                </div>
            )}
            <div
                className={`${
                    avatar ? "flex-grow-1" : `${borderMargin} center`
                } align-self-center ${
                    //mx-auto
                    !hideLeft && avatar ? "ms-3" : ""
                }`}
            >
                <div className="text-muted">
                    {title && (
                        <div className={`${titleClass}  ${!description && "mb-0"}`}>{title}</div>
                    )}
                    {description && (
                        <div className={`${descClass}  ${title ? "mb-1" : "mb-0"}`}>
                            {description}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default CustomText;
